import React, { useState } from 'react';
import styled from 'styled-components';
import DocNavigation from './DocNavigation';
import IntroducaoDoc from './IntroducaoDoc';
import Nginx from './Nginx';
import EstruturaDoc from './EstruturaDoc';
import ReactConceitosBasicosDoc from './ReactConceitosBasicosDoc';
import ComponentesDoc from './ComponentesDoc';
import RotasDoc from './RotasDoc';
import AutenticacaoDoc from './AutenticacaoDoc';
import StoreDoc from './StoreDoc';
import EstilizacaoDoc from './EstilizacaoDoc';
import CriandoPaginasDoc from './CriandoPaginasDoc';
import BoasPraticasDoc from './BoasPraticasDoc';

const Container = styled.div`
  display: flex;
  gap: 30px;
  max-width: 1400px;
  margin: 0 auto;
  padding: 20px;
  height: calc(100vh - 120px);
`;

const NavColumn = styled.div`
  flex: 0 0 280px;
  position: sticky;
  top: 20px;
  height: fit-content;
  max-height: calc(100vh - 140px);
  overflow-y: auto;
`;

const ContentColumn = styled.div`
  flex: 1;
  overflow-y: auto;
  max-height: calc(100vh - 140px);
  padding-right: 20px;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #a1a1a1;
  }
`;

const DocumentacaoContainer: React.FC = () => {
  const [activeDoc, setActiveDoc] = useState('introducao');

  const handleSelectDoc = (docId: string) => {
    setActiveDoc(docId);
  };

  const renderDocContent = () => {
    switch (activeDoc) {
      case 'introducao':
        return <IntroducaoDoc />;
      case 'nginx':
        return <Nginx />;
      case 'estrutura':
        return <EstruturaDoc />;
      case 'react-conceitos-basicos':
        return <ReactConceitosBasicosDoc />;
      case 'componentes':
        return <ComponentesDoc />;
      case 'rotas':
        return <RotasDoc />;
      case 'autenticacao':
        return <AutenticacaoDoc />;
      case 'store':
        return <StoreDoc />;
      case 'estilizacao':
        return <EstilizacaoDoc />;
      case 'criando-paginas':
        return <CriandoPaginasDoc />;
      case 'boas-praticas':
        return <BoasPraticasDoc />;
      default:
        return (
          <div>
            <h2>Em desenvolvimento</h2>
            <p>Esta seção da documentação está em desenvolvimento.</p>
          </div>
        );
    }
  };

  return (
    <div>
      <Container>
        <NavColumn>
          <DocNavigation activeDoc={activeDoc} onSelectDoc={handleSelectDoc} />
        </NavColumn>
        <ContentColumn>{renderDocContent()}</ContentColumn>
      </Container>
    </div>
  );
};

export default DocumentacaoContainer;
